<template lang="html">
    <div class="wysiwyg wrapper">
            <h3 v-if="title">{{title}}</h3>
<!--     <div v-if="image" class="image-wrapper" :class="image_align" :style="{'background-image': `url('${image.url}')`}"></div>-->
        <ImageCaption :image="image" class="image-wrapper" :class="image_align.value"></ImageCaption>
        <div class="copy" v-html="text"></div>
        <div style="clear: both"></div>
    </div>
</template>

<script>
  import ImageCaption from '@/components/image-caption/ImageCaption'
  export default {
    name: 'ImageAndText',
    components: {
      ImageCaption
    },
    props: {
      image: {
        type: [Object, Boolean],
        default: false
      },
      text: {
        type: [String, Boolean],
        default: false
      },
      title: {
        type: [String, Boolean],
        default: false
      },
      image_align: {
        type: Object,
        default: {value: 'left'}
      }
    }
  }
</script>

<style lang="scss">
    .wrapper {
        margin-top: 20px;
        h3 {
            margin-bottom: .4em;
        }
    }
</style>
<style lang="scss">
    .content-generator {
        div.wysiwyg.wrapper {
            margin-top: 3em;
        }
    }
    .image-wrapper {
        padding: 0;
        margin: 0;
        img {
            width: 40%;
            height: auto;
        }
    }
    .image-wrapper.right {
        img {
            float: right;
            margin-left: 14px;
        }
    }
    .image-wrapper.left {
        img {
            float: left;
            margin-right: 14px;
        }
    }
    .copy {
        ul {
            li {
                margin: 0 20px;
            }

        }
    }
</style>
